import styled from 'styled-components';
import { COLORS, BORDER_RADIUS, FONT_FAMILY, FONT_WEIGHT, MARGIN, DEVICE_TYPE, SIZE } from 'constants/variables';
import cursorIcon from "assets/img/Cursor.png";

export const SearchContainer = styled.div`
   width: 100%;
   padding: ${SIZE.max180} ${SIZE.max220};
   display: flex;
   flex-direction: column;
   scroll-margin-top: calc(var(--site-header-height, 80px) + 24px);
   @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: ${SIZE.max220} ${MARGIN.fix32};
   }
`;

export const SearchHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap:24px;
`;

export const InputContainer = styled.div`
  width: 100%;
  margin-bottom: ${MARGIN.fix24};
`;

export const ImgStyled = styled.img``;

export const SearchButton = styled.button<{ $biggerCursor: boolean }>`
  border: none;
  cursor: ${({ $biggerCursor }) => $biggerCursor ? `url(${cursorIcon}), auto` : "pointer"};
  padding: 6px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  background-color: ${COLORS.Cultured};
  color: ${COLORS.RaisinBlack};
  border-radius: ${BORDER_RADIUS.radius24};
  font-family: ${FONT_FAMILY.poppins};
  font-weight: ${FONT_WEIGHT.medium};
  font-size: 16px;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${COLORS.Background};
  }
  &:focus-visible { outline: 2px solid ${COLORS.Crimson}; outline-offset: 3px; }
  @media (prefers-reduced-motion: reduce) { transition: none; }
  
  svg {
    margin-right: 8px;
  }
`;

export const ResultsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 32px;
`;

export const NoResults = styled.div`
  text-align: center;
  padding: 40px 0;
  color: ${COLORS.Gunmetal};
`;
